import { render } from "./TeamList.vue?vue&type=template&id=6265b58a&scoped=true"
import script from "./TeamList.vue?vue&type=script&lang=js"
export * from "./TeamList.vue?vue&type=script&lang=js"

import "./TeamList.vue?vue&type=style&index=0&id=6265b58a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6265b58a"]])

export default __exports__